<template>
  <v-container fluid class="home pt-0">
    <v-row>
      <v-col class="pt-0">
        <v-notification/>
      </v-col>
    </v-row>

    <template v-if="loadCompleted">
      <v-row>
        <p class="ma-4 text mb-1">①②のどちらかを選んで作成してください。</p>
      </v-row>

      <v-row>
        <v-col
          cols="12"
          sm="12"
          md="6"
          lg="4"
          v-for="(item, index) in items"
          :key="index"
        >
        <div :class="savedItemClasses(index)" v-if="savedItems.preset.sheetId || savedItems.original.sheetId">
          <template v-if="savedItems.preset.sheetId && index === 0">
            ①かんたん！テスト作成で<br>途中保存のものがあります。
          </template>
          <template v-if="savedItems.original.sheetId && index === 1">
            ②じっくり！オリジナルテスト作成で<br>途中保存のものがあります。
          </template>
        </div>

          <v-clickable-card
            :detail="item.detail"
            primary
            @click="onClickCard(item)"
          >
            <template v-slot:heading>
              <v-img
                :class="item.avatarClass"
                :src="item.avatar"
              />
              <v-list-item-content>
                <v-list-item-title>{{item.title}}</v-list-item-title>
                <v-list-item-subtitle class="subtitle">{{item.subtitle}}</v-list-item-subtitle>
              </v-list-item-content>
            </template>

            <template v-slot:content>
              <v-img
                class="image"
                :src="item.src"
                height="233px"
              ></v-img>
            </template>
          </v-clickable-card>
        </v-col>

        <v-col
          cols="12"
          sm="12"
          md="12"
          lg="4"
        >
          <v-row>

            <v-col
              cols="12"
              md="4"
              lg="12"
              v-for="(item, index) in {manual, faq, changeLog}"
              :key="index"
            >
              <v-manual-card
                style='width: 144px;'
                :detail="item.detail"
                @click="openUrl(item.to)"
              >
                <template v-slot:heading>
                  <v-img
                    :class="item.avatarClass"
                    :src="item.avatar"
                  />
                </template>
              </v-manual-card>
            </v-col>

          </v-row>
        </v-col>

      </v-row>

      <v-row>
        <v-col
          cols="12"
          sm="12"
          md="6"
          lg="4"
        >
          <v-clickable-card
            :detail="history.detail"
            @click="$router.push(history.to)"
          >
            <template v-slot:heading>
              <v-img
                :class="history.avatarClass"
                :src="history.avatar"
              />
              <v-list-item-content>
                <v-list-item-title>{{history.title}}</v-list-item-title>
                <v-list-item-subtitle class="subtitle">{{history.subtitle}}</v-list-item-subtitle>
              </v-list-item-content>
            </template>
          </v-clickable-card>
        </v-col>
      </v-row>
    </template>

    <v-dialog
      v-if="item"
      v-model="restartDialog"
      persistent
      max-width="400px"
    >
      <v-card
        min-height="150px"
      >
        <v-toolbar
          class="title"
        >{{item.title}}</v-toolbar>

        <v-card-text class="px-5">
          <div class="py-3">
            <p class="mb-0">途中保存のデータがあります。</p>
            <p class="mb-0" style="font-size: 11px">※「最初から」を選択した場合は、途中保存のデータは破棄されます。</p>
          </div>
        </v-card-text>

        <v-card-actions class="card-action">
          <v-btn color="secondary" dark class="dialog-Button" @click="restart">再開</v-btn>
          <v-btn color="#6DA5E6" dark class="dialog-Button" @click="start">最初から</v-btn>
          <v-btn color="gray" class="dialog-Button" @click="restartDialog = false">閉じる</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

  </v-container>
</template>

<script>

import VClickableCard from '@/components/molecules/ClickableCard'
import VManualCard from '@/components/molecules/ManualCard'
import VNotification from '@/components/molecules/Notification'
import config from "../../config"
import Qs from 'qs'

export default {
  components: {
    VClickableCard,
    VManualCard,
    VNotification,
  },

  data: () => ({
    items: [
      {
        id: 1,
        code: 'preset',
        src: require('@/assets/img/preset-exam.png'),
        avatarClass: "avatar-hight",
        avatar: require('@/assets/img/f_f_business_91_s512_f_business_91_0nbg.png'),
        title: '① かんたん！テスト作成',
        detail: '各教科書ごとに，標準的な出題範囲，<br>問題パターンで構成されたテストをベースに，簡単に定期テストが作成できます。問題重複もなく，そのまま安心してお使いいただけます。<br>※「保健・体育」については，「かんたん！テスト作成」の設定はございません。各学校の実情に合わせて，「②じっくり！オリジナルテスト作成」より作成願います。',
        to: '/teacher/preset_exam'
      },
      {
        id: 2,
        code: 'original',
        src: require('@/assets/img/original-exam.png'),
        avatarClass: "avatar-hight",
        avatar: require('@/assets/img/f_f_business_53_s512_f_business_53_0nbg.png'),
        title: '② じっくり！オリジナルテスト作成',
        detail: '出題範囲や問題数などの条件を細かく設定して，<br>オリジナルのテストが作成できます。<br>問題重複や内容バランスに注意しながら，ご作成ください。',
        to: '/teacher/original_exam'
      },
    ],
    history: {
      id: 3,
      src: require('@/assets/img/history.png'),
      avatarClass: "avatar-wide",
      avatar: require('@/assets/img/f_f_business_42_s512_f_business_42_0nbg.png'),
      title: '申し込み履歴',
      detail: '履歴を確認することができます。',
      to: '/teacher/history'
    },
    manual: {
      id: 4,
      src: require('@/assets/img/history.png'),
      avatarClass: "avatar-manual",
      avatar: require('@/assets/img/f_f_business_42_s512_f_business_42_0nbg.png'),
      title: '',
      detail: '作成マニュアル',
      to: '/manual.pdf'
    },
    faq: {
      id: 5,
      src: require('@/assets/img/history.png'),
      avatarClass: "avatar-manual",
      avatar: require('@/assets/img/f_f_business_42_s512_f_business_42_0nbg.png'),
      title: '',
      detail: 'よくある質問',
      to: '/faq.pdf'
    },
    changeLog: {
      id: 6,
      src: require('@/assets/img/history.png'),
      avatarClass: "avatar-manual",
      avatar: require('@/assets/img/f_f_business_42_s512_f_business_42_0nbg.png'),
      title: '',
      detail: '令和4年度システム変更点',
      to: '/changeLog.pdf'
    },
    savedItems: {
      preset:   {
        sheetId: null,
        restartSheets: null
      },
      original: {
        sheetId: null,
        restartSheets: null
      },
    },
    item: null,
    targetSheetId: null,
    loadCompleted: false,
    restartDialog: false,
  }),

  async created	() {
    // 配点リセット
    this.$store.commit('setSelectedMaxPointValue', { selectedMaxPointValue: 1 })
    this.$store.commit('setSelectedMaxPoint', { selectedMaxPoint: '100' })

    //作成途中の問題があるかチェック
    await this.getSavedSheetId('preset')
    await this.getSavedSheetId('original')
    this.loadCompleted = true
  },

  methods: {
    savedItemClasses(index) {
      return {
        'arrow-box': true,
        'mx-auto': true,
        'mb-3': true,
        'balloon':  (this.savedItems.preset.sheetId && index === 0) || (this.savedItems.original.sheetId && index === 1)
      }
    },
    async getSavedSheetId(type) {
      //途中保存用にsubject_teachersを取得
      if(this.$store.state.top.subjectTeachers.length === 0) await this.$store.dispatch('getSubjectTeachers')
      //問題作成再開する必要があるか確認
      const subjectTeacherIds = this.$store.state.top.subjectTeachers.map(x => x=x.id)
      let params = {
        q: {
          subject_teacher_id_in: subjectTeacherIds,
          step_not_eq: config.step.COMPLETED,
        }
      }
      if(type==='preset') params.q.search_conditions_preset_id_not_null = true
      else if(type==='original') params.q.search_conditions_preset_id_null = true

      const restartSheets = await this.$axios.get('/api/v1/teacher/sheet/restart', {
        params: params,
        paramsSerializer: function(params) {
          return Qs.stringify(params, {arrayFormat: 'brackets'})
        }
      })

      this.savedItems[type].sheetId = restartSheets.data.id
    },
    async onClickCard(item) {
      if (this.savedItems[item.code].sheetId) {
        this.targetSheetId = this.savedItems[item.code].sheetId
        this.item = item
        this.restartDialog = true
      } else {
        // 問題検索条件リセット
        await this.$store.dispatch('initializeAllConditions')
        this.$store.dispatch('getSubjectTeachers')
        this.$router.push(item.to)
      }
    },
    cancel() {
      this.dialog = false
      this.item = null
    },
    confirm() {
      this.dialog = false
      this.$emit('confirm')
    },
    async restart() {
      const restartSheet = await this.$axios.get(`/api/v1/teacher/sheet?id=${this.targetSheetId}`)
      const params = {"restartSheets": restartSheet}
      await this.$store.dispatch('sheet/getSheetContents', params)
      if (this.item.code === 'preset') {
        const res = await this.$axios(`/api/v1/teacher/presets?q[id_eq]=${restartSheet.data.search_conditions.preset_id}`)
        const preset = this.$store.getters['sheet/convertPresetData'](res.data[0])
        // 配点を設定
        this.$store.commit('setSelectedMaxPoint', { selectedMaxPoint: restartSheet.data.search_conditions.selected_max_point })

        await this.showDetail(preset, restartSheet)
      } else if (this.item.code === 'original'){
        await this.setConditions(restartSheet.data.search_conditions)
      }

      // 試験名セット
      this.$store.commit('sheet/setTitle', { title: restartSheet.data.name })

      // 最小縮小率に達した時の解答用紙の縮小方法セット
      this.$store.commit('sheet/setAnswerReductionType', { answerReductionType: restartSheet.data.answer_reduction_type })

      // 画面遷移
      switch(restartSheet.data.step){
        case 'replace_content':
          this.$router.push('/teacher/change')
          break
        case 'preview':
          this.$router.push('/teacher/result')
          break
        case 'score_setting':
          this.$router.push('/teacher/score_setting')
          break
        case 'sheet_naming':
          this.$router.push('/teacher/regist_exam')
      }
    },
    async start() {
      await this.$store.dispatch('initializeAllConditions')
      await this.$axios.delete(`api/v1/teacher/sheets/${this.targetSheetId}`)
      // 問題検索条件リセット
      this.$store.dispatch('getSubjectTeachers')
      this.$router.push(this.item.to)
    },
    async setConditions(conditions){
      this.$store.commit('sheet/setSheetSearchCondition', {
        sheetSearchCondition: conditions
      })

      // 選択学年
      const gradeId =
        conditions[0].grade_id || config.grades.CHU1 // 社会の場合学年が空になるのでデフォルト値を補完
      const selectedGrade = this.$store.state.master.allGrades.find(x => x.id == gradeId)
      this.$store.commit('setSelectedGrade', { grade: selectedGrade } )

      // 選択教科
      const selectedSubject = this.$store.getters['master/subjectRoot'](conditions[0].subject_id)
      this.$store.commit('setSelectedSubject', { subject: selectedSubject})

      // 条件リセット
      await this.$store.dispatch('initializeAllConditions')

      conditions.forEach(condition => {
        const subject = this.$store.state.master.allSubjects.find(x => x.id == condition.subject_id)
        // 選択条件の教科を設定
        this.$store.commit(
          'setCurrentSubjectCondition',
          {
            currentSubjectCondition: this.$store.state.top.allConditions
              .find(x => x.code === subject.code)
          }
        )

        // 選択条件の詳細を設定
        const publisher = selectedSubject.publishers.find(x => x.id == condition.publisher_id)
        this.$store.commit('changeCurrentSubjectCondition', {
          selectedPublisher: publisher,
          publisherPages: condition.page_ranges.map(range => { return {start:  String(range.start), end: String(range.end)} }),
          questionNum: String(condition.question_num),
          selectedWritingQuestion: condition.writing_question_flag,
        })

        if (this.$store.getters.selectedSubjectHasChild) this.$store.commit('addSelectedShakaiOptions', { option: subject })

        // 配点を設定
        this.$store.commit('setSelectedMaxPointValue', { selectedMaxPointValue: conditions[0].selected_max_point_value })
        this.$store.commit('setSelectedMaxPoint', { selectedMaxPoint: conditions[0].selected_max_point })
      })
    },

    async showDetail(preset, restartSheets) {
      const subject = this.$store.state.master.allSubjects.find(x => x.name == preset.subjectName)
      this.$store.commit('setSelectedSubject', { subject: subject } )
      await this.$store.dispatch('initializeAllConditions')
      preset.details.forEach(detail => {
        // 社会の場合は分野をセット
        if (config.hasOptionSubjects.includes(preset.subjectCode)) {
          const option = this.$store.state.master.allSubjects.find(x => x.code === detail.subject_code)
          this.$store.commit('addSelectedShakaiOptions', { option: option })
        }

        this.$store.commit(
          'setCurrentSubjectCondition',
          {
            currentSubjectCondition: this.$store.state.top.allConditions
              .find(condition => condition.code === detail.subject_code)
          }
        )

        const publisher = subject.publishers.find(x => x.name == detail.publisher_name)
        const grade = this.$store.state.master.allGrades.find(x => x.name == preset.grade)
        const ranges = preset.rangeData.find(x => x.subjectCode === detail.subject_code)?.ranges || []

        this.$store.commit('setSelectedGrade', { grade: grade } )
        this.$store.commit('changeCurrentSubjectCondition', {
          selectedPublisher: publisher,
          publisherPages: ranges.map(range => ({ start: String(range[0]), end: String(range[1]) })),
          questionNum: String(detail.question_cnt)
        })
      })

      const params = {"preset_id": preset.id, "subject_id": restartSheets.data.search_conditions.subject_id, "restartSheets": restartSheets}
      await this.$store.dispatch('sheet/getSheetContents', params)
      //問題作成再開処理用にプリセットIDを保存
      this.$store.commit('sheet/setSheetSearchCondition', {
        sheetSearchCondition: restartSheets.data.search_conditions
      })
    },

    openUrl(url) {
      window.open(url, '_blank')
    },
  },

  computed: {
    deleteMessage() {
      return `作成途中の問題を削除します。よろしいですか。`
    }
  }
}
</script>

<style lang="stylus" scoped>
.text
  color #313131
  box-shadow 0px 2px 0px 0px #2a5594
  display inline-block

.arrow-box{
    position:relative;
    max-width:344px;
    height:60px;
    text-align:center;
    color: #FF4F41;
    font-size:15px;
    font-weight:bold;
    border-radius:48px;
}

.avatar-hight
  max-width 40px
  background-color #a5a5a5
  box-shadow 1px 1px 1px 1px #d8d8d8
  margin-right 10px

.avatar-wide
  max-width: 60px;
  background-color #a5a5a5
  box-shadow 1px 1px 1px 1px #d8d8d8
  margin-right 10px

.avatar-manual
  margin-top: 10px;
  max-width: 60px;
  background-color #a5a5a5
  box-shadow 1px 1px 1px 1px #d8d8d8

.image
  margin-top 10px
  box-shadow 0px 0px 3px 0px #b3b3b3

.title
  justify-content center
  background-color: #2a5594 !important
  color white

.card-action
  justify-content space-around

.dialog-Button
  width 100px
  height 50px

/* 吹き出し本体 */
.balloon{
  position: relative;
  padding: 10px;
  background-color: #d5eeff;
  box-shadow: 0px 0px 10px 0px #a7a7a7;         /* 吹き出し本体の影 */
}
/* 三角アイコン */
.balloon::before{
  content: '';
  position: absolute;
  display: block;
  width: 0;
  height: 0;
  left: 27px;
  bottom: -12px;
  border-right: 15px solid transparent;
  border-top: 15px solid #d5eeff;
  border-left: 15px solid transparent;
}
</style>
